const ianaTimezones = Intl.supportedValuesOf('timeZone')

const legacyTimezones = [
  // Universal Coordinated Time
  'UTC',

  // US and North America
  'US/Alaska',
  'US/Aleutian',
  'US/Arizona',
  'US/Central',
  'US/Eastern',
  'US/Hawaii',
  'US/Mountain',
  'US/Pacific',
  'Canada/Atlantic',
  'Canada/Central',
  'Canada/Eastern',
  'Canada/Mountain',
  'Canada/Newfoundland',
  'Canada/Pacific',
  'Canada/Yukon',
  'Mexico/BajaNorte',
  'Mexico/BajaSur',
  'Mexico/General',

  // Australia
  'Australia/ACT',
  'Australia/NSW',
  'Australia/North',
  'Australia/Queensland',
  'Australia/South',
  'Australia/Tasmania',
  'Australia/Victoria',
  'Australia/West',

  // MISO timezone
  'EST',
]

export const AllTimezones = [...new Set([...ianaTimezones, ...legacyTimezones])].sort()
